"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _constants = require("../../util/constants");

require("./AgentState.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AgentState = function AgentState(_ref) {
  var state = _ref.state,
      label = _ref.label,
      id = _ref.id;
  var status = _constants.AGENT_STATUS_TO_ICON[state];
  var icon = state === 'whatsappdialog' ? status[0] : status;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-agentState ".concat(state),
    "data-agent-status": state,
    id: 'glc-agentState' + id
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-agentState-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(icon, " small")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-agentState-label "
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'dots'
  }, label)), label.length > 7 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    delay: {
      show: 500,
      hide: 100
    },
    placement: "top",
    target: 'glc-agentState' + id,
    boundariesElement: "window"
  }, label));
};

AgentState.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  label: _propTypes["default"].string,
  state: _propTypes["default"].string
};
AgentState.defaultProps = {
  label: ''
};
var _default = AgentState;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/AgentState/AgentState.js
// module id = 1883
// module chunks = 0